import { useQuery } from "@tanstack/react-query";

import { getCustomNotifications } from "../../services/custom_notifications";


const useGetCustomNotifications = () => {
    return useQuery({
        queryKey: ["custom_notifications"],
        queryFn: getCustomNotifications,
        staleTime: Infinity,
        retry: 0,
    });
}

export default useGetCustomNotifications;